import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.handleEscape = this.handleEscape.bind(this)
    document.addEventListener('keydown', this.handleEscape, true)
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleEscape, true)
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      // Check if the event target is within this form
      if (this.element.contains(event.target)) {
        // Stop propagation to prevent closing parent offcanvas/modal
        event.stopPropagation()
        // Form will handle the escape (e.g., cancel button will be triggered)
      }
    }
  }

  autoSubmit(event) {
    this.element.requestSubmit();
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  // Confirms before submitting when a checkbox is being unchecked
  confirmOnUncheck(event) {
    const checkbox = event.currentTarget
    const message = checkbox.dataset.confirmMessage || 'Are you sure you want to continue?'

    // Only show confirmation when unchecking (disabling)
    if (!checkbox.checked) {
      if (!confirm(message)) {
        // User cancelled - revert the checkbox state
        checkbox.checked = true
        return
      }
    }

    this.element.requestSubmit()
  }

  submitOnEnter(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.autoSubmit();
    }
  }

  delayedSubmit(event) {
    if (this.timeout) {
      console.log("Clearing previous timeout")
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      console.log("Submitting form")
      this.element.requestSubmit()
    }, 3000)
  }

}
